import cache from '../cache';
import isAppInstall from './isAppInstall';
export default cache((scheme, androidAppName) => {
    if (!scheme) {
        return Promise.resolve(false);
    }
    return isAppInstall(scheme, androidAppName);
}, null, {
    msMaxAge: 10000,
    keyFn: (scheme, androidAppName) => scheme + androidAppName,
});
